import React from "react";

export const SignupTextInput = ({
  label,
  name,
  required = false,
  type,
  placeholder,
  defaultValue,
  onChange,
  hasError = false,
  error = "",
}) => {
  return (
    <div>
      <label htmlFor={name} className="label">
        {label}
      </label>
      <div className="relative">
        <input
          className="text-input"
          required={required}
          type={type}
          name={name}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onChange={onChange}
          sz="large"
          data-has-error={hasError}
        />
        {hasError ? <span role="input-error" /> : null}
      </div>
      {hasError ? <p className="error">{error}</p> : null}
    </div>
  );
};
